import React from "react";
import { useLocation } from "react-router-dom";

import SectionBlock from "../common/SectionBlock/SectionBlock";
import FacilitySection from "./FacilitySection/FacilitySection";
import GeneralConditionsSection from "./GeneralConditionsSection/GeneralConditionsSection";
import ReferencedNetworkSection from "./ReferencedNetworkSection/ReferencedNetworkSection";
import PQOSection from "./PQOSection/PQOSection";
import FinancialInformationSection from "./FinancialInformationSection/FinancialInformationSection";

import { ReactComponent as PregnantWomanIcon } from "../../assets/images/icons/pregnant-woman-2-icon.svg";

import {
  healthInsuranceList,
  financialInformationList,
  generalConditionsList,
  pregnantWomanList,
  readjustmentList,
} from "./Constants/HealthInsurance.constants";

export const HealthInsuranceContent = () => {
  const location = useLocation();

  const isBusiness = location.pathname.includes("/paraempresa/");

  const generalConditionTitle = isBusiness
    ? "Condições Gerais do Seguro Saúde Empresarial"
    : "Condições Gerais do Seguro Saúde";

  return (
    <>
      <FacilitySection title="Facilidades" facilityList={healthInsuranceList} />
      <SectionBlock
        title="% de reajustes de contrato"
        linkList={readjustmentList}
      />
      <GeneralConditionsSection
        title={generalConditionTitle}
        generalConditionsList={generalConditionsList}
      />
      <ReferencedNetworkSection />
      <SectionBlock
        title="Cartão da Gestante"
        linkList={pregnantWomanList}
        defaultCount={3}
        Image={PregnantWomanIcon}
        description={
          <>
            Em cumprimento à Resolução Normativa RN nº 368 da ANS,
            disponibilizamos o Cartão da Gestante, documento que possibilita
            reunir informações importantes ao longo do pré-natal para o
            acompanhamento da gestação.
          </>
        }
      />
      <PQOSection />
      <FinancialInformationSection
        title="Informações financeiras"
        financialInformationList={financialInformationList}
      />
    </>
  );
};
